import '@styles/main.scss';

if (import.meta.env.DEV) {
  import('../styles/common/_global.scss');
}

/**
 * ---------------------------------------------------------
 * IMPORT SHARED CORE FROM PARENT
 * ---------------------------------------------------------
 */

import {
  hasElement,
  ensureFlickity,
  ensureModal,
  // ensureCollapse,
  // ensureSelect2,
} from '../../../../roots/resources/assets/scripts/main';

import initCommon from './common/common';

/**
 * ---------------------------------------------------------
 * COMPONENT REGISTRY
 * ---------------------------------------------------------
 */

const components = [
  {
    selector: '.carousel',
    delay: 3000,
    child: () =>
      import('./components/misc/flickityAdditions'),
    // parent: () =>
    //   import(
    //     '../../../../roots/resources/assets/scripts/components/misc/flickityAdditions'
    //   ),
  },
  {
    selector: '.roots.cookie-consent-wrp',
    dependencies: [ensureModal],
    delay: 10000,
    child: () =>
      import('./components/cookie'),
  },
  {
    selector: '.editor-content-wrp',
    delay: 0,
    child: () =>
      import('./components/misc/editorContentAdditions'),
  },
  {
    selector: '.roots .gallery-wrapper',
    child: () =>
      import('./components/misc/jqueryViewer'),
  },
  {
    selector: '.roots.header',
    child: () =>
      import('./components/header'),
  },
  {
    selector: '.pre-footer-section',
    child: () =>
      import('./components/pre-footer'),
  },
  {
    selector: '.roots.footer',
    child: () =>
      import('./components/footer'),
  },
  {
    selector: '.roots.not-found-section',
    child: () =>
      import('./components/404'),
  },
  {
    selector: '.news-listing-section',
    child: () =>
      import('./components/listing/'),
  },
  {
    selector: '.roots.home-banner-section',
    child: () =>
      import('./components/home/banner'),
  },
  {
    selector: '.roots.page-banner-section, .page-banner-section-no-image, .page-banner-section-custom',
    child: () =>
      import('./components/banner'),
  },
  {
    selector: '.roots > .breadcrumb-wrp',
    child: () =>
      import('./components/breadcrumb'),
  },
  {
    selector: '.roots.one-column-section',
    child: () =>
      import('./components/fcp/one-column-section'),
  },
  {
    selector: '.roots.two-column-section',
    child: () =>
      import('./components/fcp/two-column-section'),
  },
  {
    selector: '.roots.three-column-section',
    child: () =>
      import('./components/fcp/three-column-section'),
  },
  {
    selector: '.roots.cards-section',
    dependencies: [ensureFlickity],
    child: () =>
      import('./components/fcp/cards-section'),
  },
  {
    selector: '.roots.gallery-section',
    dependencies: [ensureFlickity],
    child: () =>
      import('./components/fcp/gallery-section'),
  },
  {
    selector: '.roots.image-section',
    child: () =>
      import('./components/fcp/image-section'),
  },
  {
    selector: '.roots.accordion-section',
    child: () =>
      import('./components/fcp/accordion-section'),
  },
  {
    selector: '.roots.video-section',
    dependencies: [ensureModal],
    child: () =>
      import('./components/fcp/video-section'),
  },
  // {
  //   selector: '.roots.cta-section',
  //   child: () =>
  //     import('./components/fcp/cta-section'),
  // },
  {
    selector: '.roots.form-section, .editor-content-wrp form',
    child: () =>
      import('./components/fcp/form-section'),
  },
  // {
  //   selector: '.roots.logo-section',
  //   dependencies: [ensureFlickity],
  //   child: () =>
  //     import('./components/fcp/logo-section'),
  // },
  {
    selector: '.testimonials-section',
    dependencies: [ensureFlickity],
    child: () =>
      import('./components/fcp/testimonials-section'),
  },
  {
    selector: '.plans-section',
    dependencies: [ensureFlickity],
    child: () =>
      import('./components/fcp/plans-section'),
  },
  {
    selector: '.process-section',
    child: () =>
      import('./components/fcp/process-section'),
  },
  {
    selector: '.home-key-benefits-section',
    child: () =>
      import('./components/home/key-benefits'),
  },
  {
    selector: '.home-services-section',
    child: () =>
      import('./components/home/services'),
  },
  {
    selector: '.home-support-guidance-section',
    child: () =>
      import('./components/home/support-guidance'),
  },
  // {
  //   selector: '.services-banner-section',
  //   child: () =>
  //     import('./components/services/banner'),
  // },
  {
    selector: '.about-banner-section',
    child: () =>
      import('./components/about/banner'),
  },
  {
    selector: '.about-values-section',
    child: () =>
      import('./components/about/values'),
  },
  {
    selector: '.about-buddy-section',
    child: () =>
      import('./components/about/buddy'),
  },
  {
    selector: '.about-two-col-section',
    child: () =>
      import('./components/about/two-col'),
  },
  {
    selector: '.online-booking-iframe-form-section',
    child: () =>
      import('./components/online-booking/'),
  },
  {
    selector: '.featured-products-section',
    dependencies: [ensureFlickity],
    child: () =>
      import('./components/fcp/featured-products-section'),
  },
  {
    selector: '.product-card',
    child: () =>
      import('./components/woocommerce/productCard'),
  },
  {
    selector: '.product-listing-section',
    child: () =>
      import('./components/woocommerce/listing'),
  },
  {
    selector: '.product-detail-section',
    dependencies: [ensureFlickity],
    child: () =>
      import('./components/woocommerce/detail'),
  },
  {
    selector: '.quantity',
    child: () =>
      import('./components/woocommerce/quantitySelector'),
  },
  {
    selector: '.cart-section',
    child: () =>
      import('./components/woocommerce/cartSection'),
  },
  {
    selector: '.checkout-form-section',
    child: () =>
      import('./components/woocommerce/checkoutSection'),
  },
  {
    selector: '.order-received-banner-section',
    child: () =>
      import('./components/woocommerce/orderReceivedSection'),
  },
  {
    selector: '.related-products-section',
    child: () =>
      import('./components/woocommerce/relatedProducts'),
  },
];

/**
 * ---------------------------------------------------------
 * HELPERS
 * ---------------------------------------------------------
 */

function sleep(ms) {
  return new Promise((resolve) =>
    setTimeout(resolve, ms)
  );
}

/**
 * ---------------------------------------------------------
 * COMPONENT LOADER
 * ---------------------------------------------------------
 */

async function loadComponent(component) {
  const {
    selector,
    child,
    // parent,
    dependencies = [],
    delay = 0,
  } = component;

  if (!hasElement(selector)) {
    return;
  }

  await Promise.all(
    dependencies.map((dependency) => dependency())
  );

  if (delay) {
    await sleep(delay);
  }

  let module = null;

  /**
   * TRY CHILD FIRST
   */

  try {
    module = await child();

    console.log(`[Child Loaded] ${selector}`);
  } catch (error) {
    console.error(
    '[Child Import Failed]',
    selector,
    error
  );

  return;

    /**
     * FALLBACK TO PARENT
     */

    // try {
    //   module = await parent();

    //   console.log(`[Parent Fallback] ${selector}`);
    // } catch (parentError) {
    //   console.error(
    //     `[Component Missing] ${selector}`,
    //     parentError
    //   );

    //   return;
    // }
  }

  if (
    module?.default &&
    typeof module.default === 'function'
  ) {
    module.default();
  }
}

/**
 * ---------------------------------------------------------
 * INIT
 * ---------------------------------------------------------
 */

// async function loadGlobalOverrides() {
//   await import('@styles/common/_global.scss');
// }

async function initTheme() {
  initCommon(ensureModal);

  await Promise.allSettled(
    components.map((component) =>
      loadComponent(component)
    )
  );

  // await loadGlobalOverrides();
}

$(document).ready(function () {
  initTheme();
});
